import pokemonApi from '../api/pokemonApi'

/**
 * Getting a random integer between two values.
 * This example returns a random integer between the specified values.
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer), and is less than (but not equal to) max.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random#getting_a_random_integer_between_two_values
 * @param {*} min 
 * @param {*} max 
 * @returns 
 */
export const getRandomIntBetween = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

/**
 * Get an array with four random Pokemon ids between 1 and 650
 * @returns Array of four random Pokemon ids
 */
export const getPokemonIds = () => {
  let pokemonIds = []

  while (pokemonIds.length < 4) {
    const randomNumber = getRandomIntBetween(1, 650)

    if (pokemonIds.includes(randomNumber)) {
      continue
    }

    pokemonIds.push(randomNumber)
  }

  return pokemonIds
}

/**
 * Get an array with four objects that contains Pokemon's ids and names
 * @param {*} param0 An array with four Pokemon ids
 * @returns 
 */
export const getPokemonNames = async ([a, b, c, d] = []) => {
  const promiseArr = [
    pokemonApi.get(`/${a}`),
    pokemonApi.get(`/${b}`),
    pokemonApi.get(`/${c}`),
    pokemonApi.get(`/${d}`)
  ]

  const [p1, p2, p3, p4] = await Promise.all(promiseArr)

  return [p1.data, p2.data, p3.data, p4.data]
}

/**
 * Get an array with four objects about Pokemons (id and name)
 * @returns An array with four objects that contains Pokemon ids and its names
 */
const getPokemonOptions = async () => await getPokemonNames(getPokemonIds())

export default getPokemonOptions